export const urls = {
  MULTISCREEN: '/multiscreen',
};
